var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.variant === 'white')?_c('img',{staticClass:"ai-spark-icon",attrs:{"src":require("@/assets/img/sparkles-white.svg"),"width":_vm.size,"height":_vm.size,"alt":"","aria-hidden":"true"}}):_c('img',{staticClass:"ai-spark-icon",attrs:{"src":require("@/assets/img/sparklesViolet.svg"),"width":_vm.size,"height":_vm.size,"alt":"","aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }